module.exports = __webpack_public_path__ + "img/31.28150c38.png";